import HttpService from './baseHttp'

// 获取cope当前的客户项目列表
export const HttpGetCopeCusList = (data = {}) => HttpService.post("/api/v2/productLine/findByWarehouseOrgId", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 计费管理
// 计费管理分类
// 获取所有的计费分类
export const HttpGetCategory = (data = {}) => HttpService.get("/api/v2/billingCategory/findAll", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 查询单个的计费分类（编辑）
export const HttpGetCategoryOne = (data = {}) => HttpService.post("/api/v2/billingCategory/findOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存计费分类
export const HttpSaveCategoryOne = (data = {}) => HttpService.post("/api/v2/billingCategory/saveOne", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取新的计费分类的code
export const HttpGetCategoryNewCode = (data = {}) => HttpService.post("/api/v2/billingCategory/getNewCode", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 获取一级、二级、三级下拉框接口
export const HttpGetLevelList = (data = {}) => HttpService.post("/api/v2/billingCategory/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 客户费率设置
// 费率模板管理
export const HttpCusbillTemplateList = (data = {}) => HttpService.post("/api/v2/billingTemplate/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 费率模板失效、激活
export const HttOperaTemplateOne = (data = {}) => HttpService.post("/api/v2/billingTemplate/inactive", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取模板code
export const HttpGetCusbilltemplateCode = (data = {}) => HttpService.post("/api/v2/billingTemplate/getTemplateCode", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 提交创建计费模板
export const HttpSaveCusTemplateCode = (data = {}) => HttpService.post("/api/v2/billingTemplate/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取仓库作业费模板内容
export const HttpGetTemplateWarehouse = (data = {}) => HttpService.post("/api/v2/billingTemplate/getTemplateItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 保存仓库作业模板费率
export const HttpSaveTemplateWarehouse = (data = {}) => HttpService.post("/api/v2/billingTemplate/updateWarehouseOperateRate", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看单条的操作历史
export const HttpGetCusLog = (data = {}) => HttpService.post("/api/v2/billingTemplate/getTemplateItemUpdateLog", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取仓储费模板费率
export const HttpGetTempalteStorage = (data = {}) => HttpService.post("/api/v2/billingTemplate/getTemplateItem", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费率模板单条查询
export const HttpTempalteStorage = (data = {}) => HttpService.get("/api/v2/warehouseStorage/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费率模板删除
export const HttpDelTempalteStorage = (data = {}) => HttpService.post("/api/v2/warehouseStorage/delete", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费费率模板保存
export const HttpSaveTempalteStorageOne = (data = {}) => HttpService.post("/api/v2/warehouseStorage/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
//

// 客户费率列表
// 客户组织列表
export const HttpGetCusOrgList = (data = {}) => HttpService.post("/api/v2/customerRate/getCustomerOrganization", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取当前组织的仓库
// export const HttpGetCusWareList = (data = {}) => HttpService.post("/api/v2/customerRate/getHostWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetCusWareList = (config) => HttpService.post('/api/v2/customerRate/getHostWarehouse', { contextId:config || global.SYSID},{params: {contextId:config || global.SYSID}},{ baseURL:process.env.VUE_APP_APIURL_FBB})
// 根据切换客户组织获取组织列表
export const HttpGetCusOrgWareList = (data = {}) => HttpService.post("/api/v2/customerRate/getCustomerWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 换接口
export const HttpNewGetCusOrgWareList = (data = {}) => HttpService.post("/api/v2/customerRate/getAllCustomerWarehouse", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 客户费率的项目列表
export const HttpGetCusLineList = (data = {}) => HttpService.post("/api/v2/customerRate/getCustomerProductLine", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 获取当前组织仓库 包含禁用
export const HttpGetCusSystemWareList = (data = {}) => HttpService.get("/api/v2/warehouse/findAllWarehouses", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpAccountByManageList = (data = {}) => HttpService.get('/api/v1/Account/findAllByContextIdInManage', { params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_BOSS });

export const HttpAccountByOrgList = (data = {}) => HttpService.get('/api/v1/Account/findAllByContextId', { params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_BOSS });

export const HttpGetCusRateList = (data = {}) => HttpService.post("/api/v2/customerRate/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 根据费率类型获取费率模板
export const HttpGetCusRateTemplate = (data = {}) => HttpService.post("/api/v2/billingTemplate/getTemplateList", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 查看，保存客户明细
export const HttpGetCusRateOne = (data = {}) => HttpService.post("/api/v2/customerRate/findCustomerInfo", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveCusRateOne = (data = {}) => HttpService.post("/api/v2/customerRate/saveOne", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });


// 计费单列表
export const HttpGetBillingOrderList = (data = {}) => HttpService.post("/api/v2/billing/billingOrder/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 计费单 单条查询
export const HttpGetBillingOrderOne = (data = {}) => HttpService.post("/api/v2/billing/billingOrder/query_row", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 单据操作日志
export const HttpBillManageLog = (data = {}) => HttpService.post("/api/v2/OrderLog/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 计费单单条执行
export const HttpBillOrderOne = (data = {}) => HttpService.post("/api/v2/billing/billingOrder/exec", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 批量计费
export const HttpBillbatchExec = (data = {}) => HttpService.post("/api/v2/billing/billingOrder/batchExec", data, { baseURL: process.env.VUE_APP_APIURL_FBB });



// 请求计费单 详情中-》费用明细 和 费用明细的列表页面
export const HttpGetCostList = (data = {}) => HttpService.post("/api/v2/billing/billingOrder/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
//计费单 增值服务费费用明细
export const HttpBillServiceCostList = (data = {}) => HttpService.get("/api/v2/transactionDetail/findByBillOrderId", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
//计费单 包材费用明细
export const HttpBillMaterialCostList = (data = {}) => HttpService.get("/api/v2/materialDetail/findByBillOrderId", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
//  忽略异常操作
export const HttpIgnoreAbnormal = (data = {}) => HttpService.post("/api/v2/billing/billingOrder/ignoreError", data, { baseURL: process.env.VUE_APP_APIURL_FBB });


// 费用明细
// 仓储作业费
export const HttpGetWareList = (data = {}) => HttpService.post("/api/v2/billing/billingOrderTransaction/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 仓储费
export const HttpGetWarecostList = (data = {}) => HttpService.post("/api/v2/storageDetailed/findByPage", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 仓储费账单单条查询
export const HttpStorageCost = (data = {}) => HttpService.post("/api/v2/storageDetailed/findByBillId", data, { baseURL: process.env.VUE_APP_APIURL_FBB });

// 账单
// 账单管理
export const HttpBillManageList = (data = {}) => HttpService.post("/api/v2/billing/bill/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条查询账单
export const HttpBillManage = (data = {}) => HttpService.post("/api/v2/billing/bill/queryRow", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 单条账单中的费用详情
export const HttpBillManageDetail = (data = {}) => HttpService.post("/api/v2/billing/billDetail/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 账单详情-》仓库作业费查询
export const HttpWarehouseCost = (data = {}) => HttpService.post("/api/v2/billing/billingOrderTransaction/queryByBill", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 账单详情-》配送费
export const HttpDistribution = (data = {}) => HttpService.get("/api/v2/freightSettlement/item/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 账单详情=》调账查询
export const HttpAdjustAccountCost = (data = {}) => HttpService.post("/api/v2/billing/billingAdjustmant/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 确认账单
export const HttpConfirmBill = (data = {}) => HttpService.post("/api/v2/billing/bill/confirmBill", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 费用详情里面的基础信息查询
export const HttpQueryBillDetail = (data = {}) => HttpService.post("/api/v2/billing/billDetail/queryRow", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 导出明细
export const HttpGetExportDetail = (data = {}) => HttpService.post("/api/v2/billing/billDetail/export", data, { baseURL: process.env.VUE_APP_APIURL_FBB });




// 调账
export const HttpAdjustAccountList = (data = {}) => HttpService.post("/api/v2/billing/adjustmant/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });
// 创建调账
export const HttpSaveAdjustAccount = (data = {}) => HttpService.post("/api/v2/billing/adjustmant/save", data, { baseURL: process.env.VUE_APP_APIURL_FBB });



// 交易明细
export const HttpTransationRecord = (data = {}) => HttpService.post("/api/v2/funding/transactionRecord/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB });





// tobog 接口，待合并

// 包材管理查询
export const HttpMaterialList = (data, config) => HttpService.post('/api/v2/packageMaterial/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材管理保存
export const HttpSaveMaterial = (data, config) => HttpService.post('/api/v2/packageMaterial/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材管理导入
export const HttpImportMaterial = (data, config) => HttpService.post('/api/v2/packageMaterial/importInfo', data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 包材费用明细批量查询
export const HttpMaterialCostList = (data, config) => HttpService.post('/api/v2/materialDetail/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材费用明细账单查询
export const HttpMaterialCost = (data, config) => HttpService.post('/api/v2/materialDetail/findByBillId', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材费用明细条件导出
export const HttpExportMaterialCost = (data, config) => HttpService.post('/api/v2/materialDetail/export', data,{  baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 包材管理单条查询
export const HttpMaterial = (data, config) => HttpService.get('/api/v2/packageMaterial/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材管理条件导出
export const HttpExportMaterial = (data, config) => HttpService.post('/api/v2/packageMaterial/exportInfo',data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 包材管理导入模板下载
export const HttpDownloadMaterialTemplate = (data, config) => HttpService.get('/api/v2/packageMaterial/packageMaterialsTemplate', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 包材项模板查询
export const HttpMaterialTemplate = (data, config) => HttpService.post('/api/v2/billingTemplate/getTemplateItem', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 包材模板保存
export const HttpSaveMaterialTemplate = (data, config) => HttpService.post('/api/v2/billingTemplate/savePackageRate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })


// 增值服务接口
// 增值服务费用明细条件导出
export const HttpExportService = (data, config) => HttpService.post('/api/v2/transactionDetail/export', data,{ baseURL: process.env.VUE_APP_APIURL_FBB,...config  })
// 增值服务费用明细账单查询
export const HttpExtraService = (data, config) => HttpService.post('/api/v2/transactionDetail/findByBillId', data,{ baseURL: process.env.VUE_APP_APIURL_FBB })
// 增值服务费用明细批量查询
export const HttpExtraServiceList = (data, config) => HttpService.post('/api/v2/transactionDetail/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })


//费率模板
// 根据费率类型获取费率模板
export const HttpRateTemplate = (data) => HttpService.get('/api/v2/billingTemplate/getTemplateList', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


//事务项管理:基本设置
// 事务项管理批量查询
export const HttpTransactionList = (data) => HttpService.post('/api/v2/processedTransaction/findByPage', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项管理单条查询
export const HttpTransaction = (data) => HttpService.get('/api/v2/processedTransaction/findOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项管理保存
export const HttpSaveTransaction = (data) => HttpService.post('/api/v2/processedTransaction/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项管理条件导出
export const HttpExportTransaction = (data, config) => HttpService.post('/api/v2/processedTransaction/exportInfo', data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 事务项管理批量修改状态
export const HttpChangeTransactionStatus = (data) => HttpService.get('/api/v2/processedTransaction/changeStatus', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项模板查询
export const HttpTransactionTemplate = (data) => HttpService.post('/api/v2/billingTemplate/getTemplateItem', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 事务项模板保存
export const HttpSaveTransactionTemplate = (data) => HttpService.post('/api/v2/billingTemplate/saveTransactionRate', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB })


//计费单
// 计费单记录列表查询
export const HttpChargeBillList = (data) => HttpService.post('/api/v2/billing/billingOrder/query', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 计费单单体查询
export const HttpChargeBill = (data) => HttpService.post('/api/v2/billing/billingOrder/query_row', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 计费单执行
export const HttpChargeBillExec = (data) => HttpService.post('/api/v2/billing/billingOrder/exec', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 计费单仓储作业费明细查询(列表)
export const HttpWarehousBillList = (data) => HttpService.post('/api/v2/billing/billingOrderTransaction/query', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 计费单仓储作业费明细导出
export const HttpExportWarehousBill = (data, config) => HttpService.post('/api/v2/billing/billingOrderTransaction/export', data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config })


// 账单管理
// 账单明细
// 账单明细列表查询
// export const HttpBillDetail = (data, config) => HttpService.post('/api/v2/billing/billDetail/query', data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 账单单条查询
export const HttpBillDetail = (data, config) => HttpService.post('/api/v2/billing/bill/queryRow', data, { baseURL: process.env.VUE_APP_APIURL_FBB, ...config })
// 客户账单列表查询
export const HttpQueryCustomerList = (data) => HttpService.post('/api/v2/billing/bill/queryCustomer', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
//

//扣款异常记录明细查询
export const HttpAbnormalBillList = (data = {}) => HttpService.post("/api/v2/funding/transactionRecordError/query", data, { baseURL: process.env.VUE_APP_APIURL_FBB })
// 扣款异常重试按钮
export const HttpRetryAbnormal = (data) => HttpService.post('/api/v2/funding/transactionRecordError/retry', data, { baseURL: process.env.VUE_APP_APIURL_FBB })



// 冻结记录、客户账户管理、异常单据处理、配送费账单/管理
export const HttpGetFreeze = (data) => HttpService.get('/api/v2/funding/freeze/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetAccountManage = (data) => HttpService.get('/api/v2/funding/accountAmount/queryByManageOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetAbnormal = (data) => HttpService.get('/api/v2/funding/unfreeze/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 冻结记录金额汇总
export const HttpGetFreezeAmount = (data) => HttpService.get('/api/v2/funding/freeze/overviewFreezeAndUnfreeze', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })




// 根据运单号查询组织
export const HttpTrackingNoQueryOrgName = (data) => HttpService.get('/api/v2/funding/freeze/queryByTrackingNo', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// 提交单据解冻
export const HttpSaveUnfreeze = (data) => HttpService.post('/api/v2/funding/unfreeze/save', data, { baseURL: process.env.VUE_APP_APIURL_FBB })


// 配送费列表
export const HttpShipCusList = (data) => HttpService.post('/api/v2/billing/billDelivery/query', data, { baseURL: process.env.VUE_APP_APIURL_FBB })

// 配送费（管理）列表、账单确认
export const HttpShipManageList = (data) => HttpService.post('/api/v2/billing/billDelivery/queryByManageOrgId', data, { baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpSubmitShipBill = (data) => HttpService.post('/api/v2/billing/billDelivery/confirmBill', data, { baseURL: process.env.VUE_APP_APIURL_FBB })


// 账单明细、管理端
export const HttpGetShipDetail = (data) => HttpService.get('/api/v2/freightSettlement/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetManageShipDetail = (data) => HttpService.get('/api/v2/freightSettlement/queryByManageOrgId', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpGetCustomShipDetail = (data) => HttpService.get('/api/v2/freightSettlement/queryByClient', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 费用黑名单列表、删除、添加
export const HttpFeeBlackList = (data = {}) => HttpService.get("/api/v2/newBilling/expenseBlack/findByPage", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpFeeBlackDel = (data = {}) => HttpService.get("/api/v2/newBilling/expenseBlack/deleteById", {params:data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpSaveFeeBlack = (data = {}) => HttpService.post("/api/v2/newBilling/expenseBlack/save", data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_FBB });
